import React, { useState } from 'react'
import styled from 'styled-components'
import { up } from 'styled-breakpoints'

import { Link } from 'react-router-dom'
import { useAuth } from '../../../data/hooks/auth'
import { useNotificationsCount } from '../../../data/hooks/notifications'

import Logo from '../logo'
import { NumberBadge } from '../number-badge'

import ProfilePictureDropdown from './profile-picture-dropdown'
import NotificationsDropdown from './notifications/notifications_dropdown'
import SearchMenu from './search'
import HeaderMenu from './menu'


const AppHeader: React.FunctionComponent = () => {
    const { user } = useAuth()

    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false)
    const [isNotificationsDropdownOpen, setNotificationsDropdownOpen] = useState(false)

    const { messages, notifications } = useNotificationsCount()
    
    return (
        <Container>
            <Wrapper>
                <Start>
                    <Burger 
                        src={require(`./images/${isMobileMenuOpen ? 'burger_openned' : 'burger_closed'}.svg`)} 
                        onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
                    />
                    <Logo inverted={true} isBeta={true} />
                    <HeaderMenu isOpen={isMobileMenuOpen} close={() => setMobileMenuOpen(false)}/>
                </Start>

                <Finish>
                    <SearchMenu />
                    <MenuLink to={'/search'} mobileOnly={true}>
                        <Icon src={require('./images/search.svg')}/>
                    </MenuLink>
                    { user &&
                    <MenuLink to={'/messages'}>
                        <Icon src={require('./images/messages.svg')} />
                        <Number number={messages}>{messages}</Number>
                    </MenuLink>
                    }
                    { user && 
                    <MenuAction>
                        <Icon src={require('./images/notifications.svg')} onClick={() => setNotificationsDropdownOpen(!isNotificationsDropdownOpen)}/>
                        <Number number={notifications}>{notifications}</Number>
                    </MenuAction>
                    }
                    <ProfilePictureDropdown />
                </Finish>

                <NotificationsDropdown isOpen={isNotificationsDropdownOpen} />
            </Wrapper>
        </Container>
    )
}

const Container = styled.div`
    width: 100%;
    height: 72px;
    
    background: ${p => p.theme.colors.bg};
    box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.05);

    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;

    z-index: 50;

    ${up('tablet')} {
        height: 80px;
    }
`

const Wrapper = styled.div`
    position: relative;

    display: grid;
    grid-template-columns: 1fr 1fr;
    
    width: 100%;
    padding: 4px 16px;

    ${up('tablet')} {
        padding: 8px 30px;
    }

    ${up('desktop')} {
        width: 1024px;
        padding: 8px 0;
    }

    ${up('desktopBig')} {
        width: 1440px;
    }
`

const Start = styled.div`
    display: flex;
    justify-self: flex-start;
    align-items: center;
`

const Finish = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    justify-self: flex-end;
`

const MenuLink = styled(Link)<{ mobileOnly?: boolean }>`
    position: relative;

    padding: 0;
    display: grid;

    align-items: center;

    margin-right: 20px;

    ${up('tablet')} {
        display: ${p => p.mobileOnly ? 'none' : 'grid' };
    }
`

const MenuAction = styled.div`
    position: relative;
    
    padding: 0;
    display: grid;

    align-items: center;
    margin-right: 20px;

    cursor: pointer;
`

const Icon = styled.img`
    width: 20px;
    height: 20px;

    &:hover {
        filter: brightness(0) saturate(100%) invert(37%) sepia(44%) saturate(1904%) hue-rotate(219deg) brightness(89%) contrast(88%);
    }
`

const Number = styled(NumberBadge)`
    top: -10px;
    right: -10px;
    
    height: 20px;
    min-width: 20px;
    padding: 0;

    border-radius: 50%;

    font-size: 11px;
    line-height: 11px;
`

const Burger = styled.img`
    width: 24px;
    height: 24px;

    margin-right: 35px;

    cursor: pointer;

    ${up('desktop')} {
        display: none;
    }
`


export default AppHeader